(function () {
    'use strict';

    angular
        .module('udt')
        .directive('ngSrcSign', ngSrcSign);

    ngSrcSign.$inject = ['$timeout', '$http', 'AuthServerProvider', '$sanitize'];

    function ngSrcSign($timeout, $http, AuthServerProvider, $sanitize) {
        var directive = {
            restrict: 'A',
            link: link
        }

        return directive;

        function link($scope, element, attrs) {
            function revokeObjectURL() {
                if ($scope.objectURL) {
                    URL.revokeObjectURL($scope.objectURL);
                }
            }

            $scope.$on('$destroy', function () {
                revokeObjectURL();
            });

            attrs.$set('src', 'data:image/png;base64,' + '');

            if (attrs.ngSrcSign) {
                //request file data from server, attaching auth header and token
                var requestConfig = {
                    responseType: 'arraybuffer',
                    method: 'Get',
                    headers: {'Authorization': 'Bearer ' + AuthServerProvider.getToken()},
                    url: '/api/signatures/get-file' + '/' + attrs.ngSrcSign,
                    cache: 'false',
                    transformResponse: function (response, headers) {

                        var blob = new Blob(
                            [ response ],
                            { type: headers('Content-Type')}
                        );

                        $scope.objectURL = window.URL.createObjectURL(blob);

                        return $scope.objectURL
                    }
                };

                $http(requestConfig)
                    .success(function (data) {
                        attrs.$set('src', $sanitize(data));
                    });
            }
        }
    }
})();
